import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Users, MessageSquare, Plus, LogOut, Home, CalendarCheck, CheckSquare, WifiPen, User, Menu, X, ChevronLeft, ChevronRight, Newspaper } from 'lucide-react';
import { useAuth } from '../services/AuthContext';
import { Calendar } from 'lucide-react';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: Home },
    { path: '/dashboard/contacts', label: 'Contacts', icon: Users },
    { path: '/dashboard/messages', label: 'Generate Message', icon: MessageSquare },
    { path: '/dashboard/add-contact', label: 'Add Contact', icon: Plus },
    { path: '/dashboard/transcribe', label: 'AI Transcriber', icon: WifiPen },
    { path: '/dashboard/schedule', label: 'AI Scheduler', icon: CalendarCheck },
    { path: '/dashboard/calendar', label: 'Calendar', icon: Calendar },
    { path: '/dashboard/tasks', label: 'Tasks', icon: CheckSquare },

     // { path: '/dashboard/topic-scheduler', label: 'Topic Scheduler', icon: TrendingUp },
    // { path: '/dashboard/briefings', label: 'Briefings', icon: FileText },
    { path: '/dashboard/news', label: 'News Scheduler', icon: Newspaper },
    { path: '/dashboard/profile', label: 'My Profile', icon: User },
  ];

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  return (
    <>
      {/* Mobile Hamburger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: 'none',
          position: 'fixed',
          top: '1rem',
          left: '1rem',
          zIndex: 1001,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          border: 'none',
          borderRadius: '12px',
          padding: '0.75rem',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
        }}
        className="mobile-menu-btn"
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{
            display: 'none',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
          }}
          className="mobile-overlay"
        />
      )}

      {/* Sidebar */}
      <div
        style={{
          width: isCollapsed ? '80px' : '230px',
          background: 'linear-gradient(180deg, #1e293b 0%, #0f172a 100%)',
          color: 'white',
          padding: isCollapsed ? '0rem 1rem 2rem 1rem' : '0rem 1.5rem 2rem 1.5rem',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '4px 0 24px rgba(0, 0, 0, 0.1)',
          position: 'fixed',
          height: '100vh',
          left: 0,
          top: 0,
          zIndex: 1000,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
        className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}
      >
        {/* Collapse/Expand Button - Desktop Only */}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          style={{
            position: 'absolute',
            top: '8%',
            right: '-0.1rem',
            transform: 'translateY(-50%)',
            width: '14px',
            height: '38px',
            background: 'transparent',
            border: 'none',
            borderRadius: '0 8px 8px 0',
            color: 'white',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1)',
            zIndex: 1001,
          }}
          className="collapse-btn"
          onMouseEnter={(e) => {
            e.currentTarget.style.width = '28px';
            e.currentTarget.style.background = 'transparent'; // Subtle hover effect
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.width = '24px';
          }}
        >
          {isCollapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </button>

        <div style={{
          position: 'absolute',
          width: '200px',
          height: '200px',
          background: 'radial-gradient(circle, rgba(102, 126, 234, 0.15) 0%, transparent 70%)',
          borderRadius: '50%',
          top: '-100px',
          right: '-100px',
          pointerEvents: 'none',
        }} />
      
        <div style={{ 
          marginBottom: '2rem', 
          position: 'relative', 
          zIndex: 1,
          overflow: 'hidden',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}>
          {!isCollapsed ? (
            <>
              <img 
                src={`${process.env.PUBLIC_URL}/logo.png`}
                alt="Loop Logo" 
                style={{ 
                  width: '100%',
                  maxWidth: '10rem',
                  objectFit: 'contain',
                  filter: 'drop-shadow(0 10px 30px rgba(0,0,0,0.3))',
                }} 
              />
              <p style={{
                fontSize: '0.85rem',
                color: 'rgba(255, 255, 255, 0.6)',
                fontWeight: 400,
              }}>
                Smart Networking Assistant
              </p>
            </>
          ) : (
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 700,
              fontSize: '1.5rem',
              margin: '0 auto',
            }}>
              L
            </div>
          )}
        </div>

        <nav style={{ 
          flex: 1, 
          position: 'relative', 
          zIndex: 1, 
          overflowY: 'auto',
          overflowX: 'hidden',
          paddingRight: isCollapsed ? '0' : '0.5rem',
          marginRight: isCollapsed ? '0' : '-0.5rem',
        }}>
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            return (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                title={isCollapsed ? item.label : ''}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: isCollapsed ? 'center' : 'flex-start',
                  gap: '0.875rem',
                  padding: isCollapsed ? '0.875rem' : '0.875rem 1rem',
                  color: active ? 'white' : 'rgba(255, 255, 255, 0.8)',
                  background: active ? 'rgba(102, 126, 234, 0.2)' : 'transparent',
                  borderRadius: '12px',
                  marginBottom: '0.5rem',
                  transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1)',
                  fontWeight: 500,
                  cursor: 'pointer',
                  border: 'none',
                  width: '100%',
                  fontSize: '0.95rem',
                  textAlign: 'left',
                  position: 'relative',
                }}
                onMouseEnter={(e) => {
                  if (!active) {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.color = 'white';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!active) {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                  }
                }}
              >
                <Icon size={20} />
                {!isCollapsed && <span>{item.label}</span>}
              </button>
            );
          })}
        </nav>

        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          paddingTop: '1.5rem',
          position: 'relative',
          zIndex: 1,
          marginTop: 'auto',
        }}>
          {!isCollapsed ? (
            <>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.875rem',
                padding: '0.75rem',
                background: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '12px',
                marginBottom: '1rem',
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: '1.1rem',
                  flexShrink: 0,
                }}>
                  {user?.name?.charAt(0).toUpperCase()}
                </div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <h4 style={{
                    fontSize: '0.95rem',
                    color: 'white',
                    marginBottom: '0.125rem',
                    fontWeight: 600,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}>
                    {user?.name}
                  </h4>
                  <p style={{
                    fontSize: '0.8rem',
                    color: 'rgba(255, 255, 255, 0.6)',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}>
                    {user?.email}
                  </p>
                </div>
              </div>
              <button
                onClick={logout}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.875rem',
                  padding: '0.875rem 1rem',
                  color: 'rgba(255, 255, 255, 0.8)',
                  borderRadius: '12px',
                  transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1)',
                  fontWeight: 500,
                  cursor: 'pointer',
                  border: 'none',
                  background: 'transparent',
                  width: '100%',
                  fontSize: '0.95rem',
                  textAlign: 'left',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(239, 68, 68, 0.2)';
                  e.currentTarget.style.color = '#fca5a5';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                }}
              >
                <LogOut size={20} />
                Logout
              </button>
            </>
          ) : (
            <>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: '1.1rem',
                margin: '0 auto 1rem',
              }}>
                {user?.name?.charAt(0).toUpperCase()}
              </div>
              <button
                onClick={logout}
                title="Logout"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0.875rem',
                  color: 'rgba(255, 255, 255, 0.8)',
                  borderRadius: '12px',
                  transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1)',
                  fontWeight: 500,
                  cursor: 'pointer',
                  border: 'none',
                  background: 'transparent',
                  width: '100%',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(239, 68, 68, 0.2)';
                  e.currentTarget.style.color = '#fca5a5';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                }}
              >
                <LogOut size={20} />
              </button>
            </>
          )}
        </div>
      </div>

      <style>{`
        /* Hide scrollbar for Chrome, Safari and Opera */
        nav::-webkit-scrollbar {
          width: 6px;
        }

        nav::-webkit-scrollbar-track {
          background: transparent;
        }

        nav::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 3px;
        }

        nav::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.3);
        }

        /* Hide scrollbar for Firefox */
        nav {
          scrollbar-width: thin;
          scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
        }

        /* Mobile responsive styles */
        @media (max-width: 768px) {
          .mobile-menu-btn {
            display: block !important;
          }

          .mobile-overlay {
            display: block !important;
          }

          .sidebar {
            transform: translateX(-100%);
            width: 230px !important;
            padding: 0rem 1.5rem 2rem 1.5rem !important;
          }

          .sidebar-open {
            transform: translateX(0);
          }

          .collapse-btn {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
};

export default Sidebar;